import {
  useRecordContext,
  RecordContextProvider,
  NumberField,
  TabbedShowLayout,
  useTranslate,
} from "react-admin";
import Box from "@mui/material/Box";

const SaleReturnExpandList = ({ forReport }) => {
  const record = useRecordContext();
  const t = useTranslate();
  const saleReturnItems = record?.sale_return_items || [];
  const transactions = record?.transactions || [];
  return (
    <TabbedShowLayout
      syncWithLocation={false}
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
        "& .RaTabbedShowLayout-content": {
          p: 0,
        },
        "& .RaLabeled-label": {
          display: "none",
        },
      }}
    >
      <TabbedShowLayout.Tab label={t("mine.label.product")}>
        <Box
          component="table"
          sx={{
            width: "100%",
            // bgcolor: "rgba(0,0,0,.04)",
            // fontSize: "smaller",
            borderCollapse: "collapse",
            "& th, td": {
              padding: "2px 8px",
              border: "1px solid #dddddd",
            },
          }}
        >
          <thead>
            <tr>
              <th>SJ. Number</th>
              <th>{t("mine.label.product_code")}</th>
              <th>{t("mine.label.product_name")}</th>
              <th style={{ textAlign: "right" }}>{t("mine.label.sent")}</th>
              <th style={{ textAlign: "right" }}>{t("mine.label.return")}</th>
              <th style={{ textAlign: "right" }}>{t("mine.label.cogs")}</th>
              <th style={{ textAlign: "right" }}>{t("mine.label.price")}</th>
              <th style={{ textAlign: "right" }}>
                {t("mine.label.discount_per_box")}
              </th>
              <th style={{ textAlign: "right" }}>
                {t("mine.label.special_discount_per_box")}
              </th>
              <th style={{ textAlign: "right" }}>
                {t("mine.label.transport_discount")}
              </th>
              <th style={{ textAlign: "right" }}>Subtotal</th>
              <th>{t("mine.label.warehouse")}</th>
            </tr>
          </thead>
          <tbody>
            {saleReturnItems
              .filter((item) => item.return_quantity > 0)
              .map((item, idx) => {
                const hpp =
                  item.sale_item && item.sale_item.sale_item_hpps
                    ? item.sale_item.sale_item_hpps[0]
                    : null;
                return (
                  <tr key={item.id + idx}>
                    <td>{item.sale_item.sale.code}</td>
                    <td>{item.sale_item.product.code}</td>
                    <td>{item.sale_item.product.name}</td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          source="sale_item.sent_quantity"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={hpp || { inventory: {} }}>
                        <NumberField
                          source="inventory.cogs"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          source="return_quantity"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider
                        value={
                          item.sale_item &&
                          item.sale_item.sale &&
                          item.sale_item.sale.code &&
                          item.sale_item.sale.code.endsWith("P")
                            ? { sale_item: { price: 0 } }
                            : item
                        }
                      >
                        <NumberField
                          source="sale_item.price"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          source="sale_item.disc"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          source="sale_item.spc_disc"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          emptyText="0"
                          transform={(val) => (+val < 0 ? +val * -1 : val)}
                          source="sale_item.transport_cost"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          source="subtotal"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td>{item.warehouse.name ? item.warehouse.name : "-"}</td>
                  </tr>
                );
              })}
          </tbody>
        </Box>
      </TabbedShowLayout.Tab>
      {!forReport && transactions.length ? (
        <TabbedShowLayout.Tab label={t("mine.label.journal")}>
          <Box
            component="table"
            sx={{
              width: "100%",
              // bgcolor: "rgba(0,0,0,.04)",
              // fontSize: "smaller",
              borderCollapse: "collapse",
              "& th, td": {
                padding: "6px 8px",
                border: "1px solid #dddddd",
              },
            }}
          >
            <thead>
              <tr>
                <th>COA</th>
                <th>{t("mine.label.coa_name")}</th>
                <th>{t("mine.label.description")}</th>
                <th style={{ textAlign: "right" }}>{t("mine.label.debit")}</th>
                <th style={{ textAlign: "right" }}>{t("mine.label.credit")}</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((item, idx) => {
                return (
                  <tr key={item.id + idx}>
                    <td>{item.coa.code}</td>
                    <td>{item.coa.name}</td>
                    <td>{item.description}</td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          source="debit"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          source="credit"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Box>
        </TabbedShowLayout.Tab>
      ) : null}
    </TabbedShowLayout>
  );
};

export default SaleReturnExpandList;
